import React from 'react';

export default React.memo(function ButtonOutlined({ className = '', children, ...props }) {
  return (
    <button {...props} className={`btn__outlined rounded-2xl inline-block select-none ${className}`}>
      {children}
    </button>
  )
})
